export default "__VITE_ASSET__BiuVG9rd__"